import React from 'react';

const ExportButton = ({ onClick, disabled, style, className }) => {
    return (
        <button
            type="button"
            className={`btn btn-primary waves-effect waves-light export-btn-mobile ${className || ''}`}
            disabled={disabled}
            onClick={onClick}
            style={style}
        >
            <span>Export</span>
        </button>
    );
};

export default ExportButton;
